"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const membership_1 = require("../membership");
const salesforce_1 = require("../salesforce");
const b2b_membership_types_tiers_1 = require("./b2b-membership-types-tiers");
var MembershipScope;
(function (MembershipScope) {
    MembershipScope[MembershipScope["UNKNOWN"] = 0] = "UNKNOWN";
    MembershipScope[MembershipScope["NONMEMBER"] = 1] = "NONMEMBER";
    MembershipScope[MembershipScope["MEMBER"] = 2] = "MEMBER";
})(MembershipScope = exports.MembershipScope || (exports.MembershipScope = {}));
var MembershipIdsEnum;
(function (MembershipIdsEnum) {
    MembershipIdsEnum["NON_MEMBER"] = "nonMemberRole";
    MembershipIdsEnum["LOGGED_IN"] = "loggedInRole";
    MembershipIdsEnum["MRUSR0001"] = "excacc.MRUSR0001";
    MembershipIdsEnum["MRUSR0002"] = "excacc.MRUSR0002";
    MembershipIdsEnum["MRUSR0003"] = "excacc.MRUSR0003";
    MembershipIdsEnum["MRUSR0004"] = "excacc.MRUSR0004";
    MembershipIdsEnum["MRUSR0005"] = "excacc.MRUSR0005";
    MembershipIdsEnum["MRUSR0006"] = "excacc.MRUSR0006";
    MembershipIdsEnum["MRUSR0007"] = "excacc.MRUSR0007";
    MembershipIdsEnum["MRUSR0008"] = "excacc.MRUSR0008";
    MembershipIdsEnum["MRUSR0009"] = "excacc.MRUSR0009";
    MembershipIdsEnum["MRUSR0010"] = "excacc.MRUSR0010";
    MembershipIdsEnum["MRUSR0011"] = "excacc.MRUSR0011";
    MembershipIdsEnum["MRUSR0012"] = "excacc.MRUSR0012";
    MembershipIdsEnum["MRUSR0013"] = "excacc.MRUSR0013";
    MembershipIdsEnum["MRUSR0014"] = "excacc.MRUSR0014";
    MembershipIdsEnum["MRUSR0015"] = "excacc.MRUSR0015";
    MembershipIdsEnum["MRUSR0018"] = "excacc.MRUSR0018";
    MembershipIdsEnum["MRUSR0019"] = "excacc.MRUSR0019";
    MembershipIdsEnum["MRUSR0022"] = "excacc.MRUSR0022";
    MembershipIdsEnum["MRUSR0023"] = "excacc.MRUSR0023";
    MembershipIdsEnum["MRUSR0024"] = "excacc.MRUSR0024";
    MembershipIdsEnum["MRUSR0025"] = "excacc.MRUSR0025";
    MembershipIdsEnum["MRUSR0026"] = "excacc.MRUSR0026";
    MembershipIdsEnum["MRUSR0027"] = "excacc.MRUSR0027";
    MembershipIdsEnum["MRUSR0028"] = "excacc.MRUSR0028";
    MembershipIdsEnum["MRUSR0031"] = "excacc.MRUSR0031";
    MembershipIdsEnum["MRUSR0032"] = "excacc.MRUSR0032";
    MembershipIdsEnum["MRUSR0033"] = "excacc.MRUSR0033";
    MembershipIdsEnum["MRUSR0034"] = "excacc.MRUSR0034";
    MembershipIdsEnum["MRUSR0035"] = "excacc.MRUSR0035";
    MembershipIdsEnum["MRUSR0036"] = "excacc.MRUSR0036";
    MembershipIdsEnum["MRUSR0041"] = "excacc.MRUSR0041";
    MembershipIdsEnum["MRUSR0042"] = "excacc.MRUSR0042";
    MembershipIdsEnum["MRUSR0043"] = "excacc.MRUSR0043";
    MembershipIdsEnum["MRUSR0044"] = "excacc.MRUSR0044";
    MembershipIdsEnum["MRUSR0045"] = "excacc.MRUSR0045";
    MembershipIdsEnum["MRUSR0046"] = "excacc.MRUSR0046";
    MembershipIdsEnum["MRUSR0047"] = "excacc.MRUSR0047";
    MembershipIdsEnum["MRUSR0048"] = "excacc.MRUSR0048";
    MembershipIdsEnum["MRUSR0049"] = "excacc.MRUSR0049";
    MembershipIdsEnum["MRUSR0050"] = "excacc.MRUSR0050";
    MembershipIdsEnum["MRUSR0051"] = "excacc.MRUSR0051";
    MembershipIdsEnum["MRUKR0001"] = "excacc.MRUKR0001";
    MembershipIdsEnum["Subscription001"] = "Content.Subscription001";
    MembershipIdsEnum["Subscription002"] = "Content.Subscription002";
    MembershipIdsEnum["Subscription003"] = "Content.Subscription003";
    MembershipIdsEnum["Subscription004"] = "Content.Subscription004";
    MembershipIdsEnum["FREE_TRIAL"] = "free-trial";
    MembershipIdsEnum["Centers_Affiliated"] = "centers-member-partner-affiliated";
})(MembershipIdsEnum = exports.MembershipIdsEnum || (exports.MembershipIdsEnum = {}));
// OktaRoleId of 2 FVS types in Contentful - Section
var FVSSectionMembershipIdsEnum;
(function (FVSSectionMembershipIdsEnum) {
    FVSSectionMembershipIdsEnum["FORENSIC"] = "FVS.FORENSIC";
    FVSSectionMembershipIdsEnum["VALUATION"] = "FVS.VALUATION";
})(FVSSectionMembershipIdsEnum = exports.FVSSectionMembershipIdsEnum || (exports.FVSSectionMembershipIdsEnum = {}));
/**
 * The membership tiers.
 *
 * @category Membership
 */
var MembershipTiers;
(function (MembershipTiers) {
    MembershipTiers["BASE"] = "base";
    MembershipTiers["COMPLIANCE"] = "compliance";
    MembershipTiers["CAREER_DEVELOPER"] = "career developer";
    MembershipTiers["SENIOR_LEADER"] = "senior leader";
    MembershipTiers["AMBASSADOR"] = "ambassador";
    MembershipTiers["FACULTY"] = "faculty";
    MembershipTiers["FREE"] = "free";
    MembershipTiers["PRE_MEMBERSHIP"] = "pre-membership";
    MembershipTiers["VOTING"] = "voting";
    MembershipTiers["VOTING_GRATIS"] = "voting gratis";
    MembershipTiers["NON_VOTING"] = "non-voting";
})(MembershipTiers = exports.MembershipTiers || (exports.MembershipTiers = {}));
/**
 * The membership types available
 *
 * @category Membership
 */
var MembershipTypes;
(function (MembershipTypes) {
    MembershipTypes["AFFILIATE"] = "Affiliate";
    MembershipTypes["CANDIDATE"] = "Candidate";
    MembershipTypes["REGULAR"] = "Regular";
    MembershipTypes["RETIRED"] = "Retired";
    MembershipTypes["INTERNATIONAL_ASSOCIATE"] = "International-Associate";
    MembershipTypes["CGMA_AFFILIATE"] = "Cgma-Affiliate";
})(MembershipTypes = exports.MembershipTypes || (exports.MembershipTypes = {}));
exports.SupportedMembershipTypeTierMap = {
    [b2b_membership_types_tiers_1.B2BMembershipTypes.AFFILIATE]: Object.values(b2b_membership_types_tiers_1.B2BMembershipTiers),
    [b2b_membership_types_tiers_1.B2BMembershipTypes.CANDIDATE]: Object.values(b2b_membership_types_tiers_1.B2BMembershipTiers),
    [b2b_membership_types_tiers_1.B2BMembershipTypes.REGULAR]: Object.values(b2b_membership_types_tiers_1.B2BMembershipTiers),
    [b2b_membership_types_tiers_1.B2BMembershipTypes.RETIRED]: Object.values(b2b_membership_types_tiers_1.B2BMembershipTiers),
    [b2b_membership_types_tiers_1.B2BMembershipTypes.PRE_CANDIDATE]: Object.values(b2b_membership_types_tiers_1.B2BMembershipTiers),
    [b2b_membership_types_tiers_1.B2BMembershipTypes.INTERNATIONAL_ASSOCIATE]: Object.values(b2b_membership_types_tiers_1.B2BMembershipTiers),
};
var SuppressionType;
(function (SuppressionType) {
    SuppressionType["LAPSING"] = "Automated lapsing journey suppression only";
    SuppressionType["MARKETING_RENEWAL"] = "Marketing/renewal communications suppression only";
    SuppressionType["FULL"] = "Full suppression (both of the above)";
    SuppressionType["FLP"] = "FLP Communication Suppression only";
})(SuppressionType = exports.SuppressionType || (exports.SuppressionType = {}));
var SuppressionReason;
(function (SuppressionReason) {
    SuppressionReason["GOODWILL"] = "Goodwill";
    SuppressionReason["POLITICAL"] = "Political / geographic situation";
    SuppressionReason["HARDSHIP"] = "Hardship";
    SuppressionReason["FIRM_BILLING_EXIT"] = "Firm billing exit";
    SuppressionReason["FIRM_BILLING"] = "Firm billing";
    SuppressionReason["FLP_FIRM_BILLING_EXIT"] = "FLP Firm billing exit";
    SuppressionReason["FLP_FIRM_BILLING"] = "FLP Firm Billing";
    SuppressionReason["PAYMENT_ISSUES"] = "Payment issues";
    SuppressionReason["RESIGNATION_PENDING"] = "Resignation pending";
    SuppressionReason["OTHER"] = "Other";
})(SuppressionReason = exports.SuppressionReason || (exports.SuppressionReason = {}));
exports.MembershipRecordTypeMap = {
    [membership_1.MembershipKeys.REGULAR]: salesforce_1.RecordTypeName.INDIVIDUAL_MEMBERSHIP_REGULAR,
    [membership_1.MembershipKeys.CANDIDATE]: salesforce_1.RecordTypeName.INDIVIDUAL_MEMBERSHIP_CANDIDATE,
    [membership_1.MembershipKeys.AFFILIATE]: salesforce_1.RecordTypeName.INDIVIDUAL_MEMBERSHIP_AFFILIATE,
    [membership_1.MembershipKeys.RETIRED]: salesforce_1.RecordTypeName.INDIVIDUAL_MEMBERSHIP_RETIRED,
    [membership_1.MembershipKeys.INTERNATIONAL_ASSOCIATE]: salesforce_1.RecordTypeName.INDIVIDUAL_MEMBERSHIP_INTERNATIONAL_ASSOCIATE,
};
exports.ABVCredentialRecordTypeMap = {
    [membership_1.CredentialPathwayKeys['conventional-cpas']]: 'ABV',
    [membership_1.CredentialPathwayKeys['conventional-finance']]: 'ABV FP',
    [membership_1.CredentialPathwayKeys.reinstatement]: 'ABV Reinstatement',
};
exports.CEIVCredentialRecordTypeMap = {
    [membership_1.CredentialPathwayKeys['conventional-cpas']]: 'CEIV CPA',
    [membership_1.CredentialPathwayKeys['conventional-finance']]: 'CEIV FP',
    [membership_1.CredentialPathwayKeys.reinstatement]: 'CEIV Reinstatement',
};
exports.CFFCredentialRecordTypeMap = {
    [membership_1.CredentialPathwayKeys.certificate]: 'CFF Certificate',
    [membership_1.CredentialPathwayKeys.experienced]: 'CFF Experienced',
    [membership_1.CredentialPathwayKeys.reinstatement]: 'CFF Reinstatement',
    [membership_1.CredentialPathwayKeys.standard]: 'CFF Standard',
};
exports.CITPCredentialRecordTypeMap = {
    [membership_1.CredentialPathwayKeys.certificate]: 'CITP Certificate',
    [membership_1.CredentialPathwayKeys.experienced]: 'CITP Experienced',
    [membership_1.CredentialPathwayKeys.reinstatement]: 'CITP Reinstatement',
    [membership_1.CredentialPathwayKeys.standard]: 'CITP Standard',
};
exports.CVFICredentialRecordTypeMap = {
    [membership_1.CredentialPathwayKeys['conventional-finance']]: 'CVFI Conventional FP',
    [membership_1.CredentialPathwayKeys.reinstatement]: 'CVFI Reinstatement',
    [membership_1.CredentialPathwayKeys['conventional-cpas']]: 'CVFI Conventional CPA',
    [membership_1.CredentialPathwayKeys['experienced-finance']]: 'CVFI Experienced FP',
    [membership_1.CredentialPathwayKeys['experienced-cpas']]: 'CVFI Experienced CPA',
};
exports.PFSCredentialRecordTypeMap = {
    [membership_1.CredentialPathwayKeys.standard]: 'PFS Standard',
    [membership_1.CredentialPathwayKeys.experienced]: 'PFS Experienced',
    [membership_1.CredentialPathwayKeys.reinstatement]: 'PFS Reinstatement',
    [membership_1.CredentialPathwayKeys.certificate]: 'PFS Certificate',
};
exports.CGMACredentialRecordTypeMap = {
    [membership_1.CredentialPathwayKeys.standard]: 'CGMA Designation',
};
//# sourceMappingURL=membership-types.js.map